import { render, staticRenderFns } from "./CategorizedIcon.vue?vue&type=template&id=1454b17f"
import script from "./CategorizedIcon.vue?vue&type=script&lang=js"
export * from "./CategorizedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports